import React, { useState, useEffect, useRef, useCallback } from "react";
//Redux
import { useSelector, useDispatch } from 'react-redux'
import { componentIntermediateSelector } from 'state-management/actions'
import { getGlobalProps } from 'state-management/selectors'
import Label from "components/general/Label"
//Responsive
import { useViewport } from 'components/general/useViewPort';
import { Pagination, Navigation, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { findArray, getURL } from 'helpers/utils'
import { isLiveStatus } from "helpers/status";
import { scheduleIsHigherGettingReady } from "helpers/status";
import { useNavigate } from 'react-router-dom';
import SportCode from "components/common/SportCode"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const renderLabelTRI = (intermediate, config, data, style) => {

    let legLabel = intermediate?.sector?.leg?.value && <><Label data={'HeaderLeg'} /> :  {intermediate?.sector?.leg?.value} </>
    let configSplit = (intermediate?.sector?.code !== undefined)
        ? <span>{legLabel}<Label data={`Header${intermediate?.sector?.code}`} /></span>
        : <span> </span>


    let ratio = ''
    if (!config?.hidePassed) {
        const starters = data?.starters
        const passed = data?.passed?.find(item => item.ei_pos === intermediate.pos)?.ei_value;
        ratio = starters !== undefined && passed !== undefined ? `${passed}/${starters}` : ''
    }

    let splitDistance = (intermediate?.sector?.valueIntermediate !== undefined)
        ? (intermediate?.sector?.code === 'SWIM')
            ? <span> {intermediate?.sector?.valueIntermediate}<Label data='LabelM' /></span>
            : <span> {intermediate?.sector?.valueIntermediate}<Label data='LabelKm' /></span>
        : ''

    let header = data.finalPosition === intermediate.position
        ? <Label data="HeaderFinish" />
        : <span>{configSplit} {splitDistance}</span>

    return (
        <div className={`box-data${style ? ' ' + style : ''}`}>
            <div className='box-data-up'>{header}</div>
        </div>
    )


}

const renderLabelOws = (intermediate, config, data, style, mirs_discipline) => {

    const exception = config?.distance?.exceptions?.find(exception => exception.pos === intermediate.pos);
    if (exception !== undefined) {
        return (
            <div className={style}><Label data={exception.label} /></div>
        )
    }

    let ratio = ''
    if (!config?.hidePassed) {
        const starters = data?.starters
        const passed = data?.passed?.find(item => item.ei_pos === intermediate.pos)?.ei_value;
        ratio = starters !== undefined && passed !== undefined ? `${passed}/${starters}` : ''
    }

    let type = findArray(intermediate?.extension, { code: ['NAME'] })?.value
    let lap = (type !== undefined)
        ? <> <SportCode code={type} discipline={mirs_discipline} entity="@IntPtType" /> - </>
        : ''

    const resultStatus = data?.status;
    const isLive = isLiveStatus(resultStatus) ? true : false

    return (
        <div className={`box-data${style ? ' ' + style : ''}`}>
            <div className='box-data-up'>
                {intermediate?.value === '10.0'
                    ? <><Label data='HeaderFinish' /></>
                    : <>{lap}{intermediate?.value}{config?.distance?.unit}</>
                }
            </div>
            <div className='box-data-down'>
                {isLive
                    ? ratio
                    : ''
                }
            </div>
        </div>
    )
}

const renderLabel = (intermediate, config, data, style) => {
    const exception = config?.distance?.exceptions?.find(exception => exception.pos === intermediate.pos);
    if (exception !== undefined) {
        return (
            <div className={`box-data${style ? ' ' + style : ''}`}><Label data={exception.label} /></div>
        )
    }

    let ratio = ''
    if (!config?.hidePassed) {
        const starters = data?.starters
        const passed = data?.passed?.find(item => item.ei_pos === intermediate.pos)?.ei_value;
        ratio = starters !== undefined && passed !== undefined ? `${passed}/${starters}` : ''
    }

    return (
        <div className={`box-data${style ? ' ' + style : ''}`}>
            <div className='box-data-up'>{intermediate?.value}{config?.distance?.unit}</div>
            <div className='box-data-down'>{ratio}</div>
        </div>
    )
}

const renderLabelGEN = (intermediate, config, data, style) => {

    let numCols = data?.finalPosition;
    let lb = <Label data="LabelMeters" />

    if (config?.distance?.unit === 'km') {
        lb = <Label data="LabelKm" />
    }
    let _header = <>{intermediate?.data?.value}&nbsp;{lb}</>
    _header = Number(intermediate.position) === Number(numCols) ? intermediate?.data?.value : _header

    //Removes distance unit if it is the half point
    _header = intermediate?.data?.value === 'Half' ? intermediate?.data?.value : _header
    return (
        <div className={`box-data${style ? ' ' + style : ''}`}>
            <div className='box-data-up'>{_header}</div>
        </div>
    )

}

const renderLabelMPN = (intermediate, config, data, style) => {
    const exception = config?.distance?.exceptions?.find(exception => exception.pos === intermediate.pos);
    if (exception !== undefined) {
        return (
            <div className={`box-data${style ? ' ' + style : ''}`}><Label data={exception.label} /></div>
        )
    }
    let extension
    if (intermediate?.pos === 'F') {
        extension = Label({ data: 'LabelFinish' })
    } else {
        //extension = intermediate?.extension?.find(ex => ex.code === 'LAP' + intermediate?.pos)?.value

        let code = intermediate?.extension?.find(x => x !== undefined)?.value //first element defined in this way must be always LAP value
        extension = (code !== undefined)
            ? SportCode({ code: code, entity: "@IntPtType", isText: true })
            : ''


    }
    let lb = <Label data="LabelMeters" />
    return (
        <div className={`box-data${style ? ' ' + style : ''}`}>
            <div className='box-data-up'>{extension} - {intermediate?.value}{lb}</div>
        </div>
    )
}

const ProgressBar = ({ data, config, dinamic, }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const swiperRef = useRef()
    const globalProps = useSelector(getGlobalProps)
    const dispatch = useDispatch();
    const [colsH, setColsH] = useState([]);
    const [hasStart, setHasStart] = useState(false);

    const isClickable = (pos) => {
        return dinamic && pos !== 'S'
    }
    const maxCol = parseInt(data?.finalPosition);
    //Change this in order to pass by config
    if (!config?.numColVisibles) {
        config.numColVisibles = { sm: 1, lg: 3 }
    }


    let _breakpoints = config.breakpoints || {
        576: {
            slidesPerView: 3,
            //spaceBetween: 20,
        },
        768: {
            slidesPerView: 4,
            //spaceBetween: 40,
        },
        1024: {
            slidesPerView: 6,
            //spaceBetween: 50,
        },
    }

    const extendedColsVisibles = breakPoint === "sm" || breakPoint === "xs" ? config.numColVisibles?.sm : config.numColVisibles?.lg;

    useEffect(() => {
        const currentSplit = data?.currentPosition
        const finalPosition = data?.finalPosition
        let intermediateSelector = Object.assign({}, globalProps.intermediateSelector);
        intermediateSelector.current = currentSplit?.toString();
        intermediateSelector.extendedColsVisibles = extendedColsVisibles;
        intermediateSelector.finalPosition = finalPosition
        if (intermediateSelector.isLive) {
            intermediateSelector.selected = currentSplit?.toString();
        }
        dispatch(componentIntermediateSelector(intermediateSelector))
    }, [data, extendedColsVisibles])

    useEffect(() => {
        let numVisibles = globalProps?.intermediateSelector?.extendedColsVisibles ? globalProps?.intermediateSelector?.extendedColsVisibles - 1 : 1
        let pos = 0;
        if (globalProps?.intermediateSelector?.current) {
            if (globalProps?.intermediateSelector?.isLive) {
                pos = globalProps?.intermediateSelector?.current;
            } else {
                pos = globalProps?.intermediateSelector?.selected;
            }

            let offset = hasStart ? 0 : 1
            if (numVisibles > 1) {
                swiperRef.current.slideTo(((pos === 'F' ? maxCol : pos) - numVisibles) - offset)
            } else {
                swiperRef.current.slideTo((pos === 'F' ? maxCol : pos) - offset)
            }

        }

        if (dinamic && globalProps?.intermediateSelector?.isLive) {
            getColsHighlight(globalProps?.intermediateSelector?.current)
        } else if (dinamic) {
            getColsHighlight(globalProps?.intermediateSelector?.selected)
        } else if (!dinamic) {
            getColsHighlight(globalProps?.intermediateSelector?.current)
        }
    }, [setHasStart, globalProps.intermediateSelector])

    useEffect(() => {
        if (Array.isArray(data?.intermediates) && data?.intermediates?.find(item => item.pos === "S")) {
            setHasStart(true)
        }

    }, [])




    const getColsHighlight = (pos) => {
        const extendedColsVisibles = parseInt(globalProps?.intermediateSelector?.extendedColsVisibles);

        const selectedPos = pos === 'F' ? maxCol : parseInt(pos);
        let columns = [];
        for (let i = 1; i <= extendedColsVisibles; i++) {
            let value = ''
            let style = "selected2"
            if (selectedPos <= extendedColsVisibles) {
                value = i + '';
            } else {
                if ((i + selectedPos - extendedColsVisibles) === maxCol) {
                    value = 'F'
                } else {
                    value = (i + selectedPos - extendedColsVisibles) + ''
                }
            }
            if (selectedPos <= extendedColsVisibles && i === selectedPos) {
                style = "selected1"
            } else if (selectedPos > extendedColsVisibles && (i + selectedPos - extendedColsVisibles) === selectedPos) {
                style = "selected1"
            }
            columns[i - 1] = { pos: value, style: style };
        }
        setColsH(columns);
    }

    const handleClick = (item) => {
        if (isClickable(item.pos)) {
            // Use Redux to store selected intermediate and set is live to false
            let intermediateSelector = Object.assign({}, globalProps.intermediateSelector);
            intermediateSelector.selected = item.pos;
            intermediateSelector.isLive = false
            dispatch(componentIntermediateSelector(intermediateSelector))
            //higlight component
            getColsHighlight(item.pos);
        }
    }
    let currentPos;
    if (!data.currentPosition || data?.currentPosition < 0) {
        currentPos = 0;
    } else if (data?.currentPosition && isNaN(data?.currentPosition) && data?.currentPosition?.includes("F")) {
        currentPos = data?.finalPosition;
    } else {
        //currentPos = Number(data?.currentPosition);
        let offset = hasStart ? 0 : 1
        currentPos = Number(data?.currentPosition) - offset;
    }

    return (
        <div className='container mirs-timeline-container' >
            < Swiper
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
                // slidesPerView={globalProps.intermediateSelector.selected}
                spaceBetween={0}
                navigation={true}
                pagination={{ clickable: true, }}
                breakpoints={_breakpoints}
                modules={[Pagination, Navigation, A11y]}
                className="timeline"
            // observer={true}
            >
                {Array.isArray(data?.intermediates) && data?.intermediates?.map((item, index) => {
                    let isActive = index <= currentPos && !config?.hideProgress
                    let className = isActive ? "progression-point active" : "progression-point non-active";
                    let hasCursor = dinamic && item.pos !== 'S'
                    className = hasCursor ? className + " cursorPointer" : className;
                    let style = colsH.find(col => col.pos === item.pos)?.style;

                    let labelComponent
                    switch (mirs_discipline) {
                        case 'MPN': {
                            labelComponent = renderLabelMPN(item, config, data, style)
                            break;
                        }
                        default: {
                            labelComponent = renderLabel(item, config, data, style)
                            break;
                        }
                    }

                    return (

                        <SwiperSlide
                            className='timeline-item'
                            data-unit={data.code}
                            key={`timeline-item${index}`}
                        >
                            <span
                                //key={`progress-item-${index}`}
                                className={className}
                                onClick={() => handleClick(item)}>
                                {labelComponent}
                            </span>
                        </SwiperSlide >
                    );
                }
                )}
            </Swiper>
        </div >


    );
}

export const ProgressBarTRI = ({ data, config, dinamic }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const swiperRef = useRef()
    const globalProps = useSelector(getGlobalProps)
    const dispatch = useDispatch();
    const [colsH, setColsH] = useState([]);
    const [hasStart, setHasStart] = useState(false);

    const isClickable = (pos) => {
        return dinamic && pos !== 'S'
    }

    const maxCol = parseInt(data?.finalPosition);
    //Change this in order to pass by config

    if (!config?.numColVisibles) {
        config.numColVisibles = { sm: 1, lg: 3 }
    }

    let _breakpoints = config.breakpoints || {
        576: {
            slidesPerView: 3,
            //spaceBetween: 20,
        },
        768: {
            slidesPerView: 4,
            //spaceBetween: 40,
        },

        1024: {
            slidesPerView: 6,
            //spaceBetween: 50,
        },
    }

    const extendedColsVisibles = breakPoint === "sm" || breakPoint === "xs" ? config.numColVisibles?.sm : config.numColVisibles?.lg;

    useEffect(() => {
        if (data?.intermediates?.find(item => item?.data?.pos === "S")) {
            setHasStart(true)
        }
    }, [])

    useEffect(() => {
        const currentSplit = data.currentPosition
        const finalPosition = data.finalPosition
        let intermediateSelector = Object.assign({}, globalProps.intermediateSelector);
        intermediateSelector.current = currentSplit?.toString();
        intermediateSelector.extendedColsVisibles = extendedColsVisibles;
        intermediateSelector.finalPosition = finalPosition
        if (intermediateSelector.isLive) {
            intermediateSelector.selected = currentSplit?.toString();
        }
        dispatch(componentIntermediateSelector(intermediateSelector))
    }, [data, extendedColsVisibles])

    useEffect(() => {
        let numVisibles = globalProps?.intermediateSelector?.extendedColsVisibles ? globalProps?.intermediateSelector?.extendedColsVisibles : 1
        let pos = 0;
        if (globalProps?.intermediateSelector?.current) {
            if (globalProps?.intermediateSelector?.isLive) {
                pos = globalProps?.intermediateSelector?.current;
            } else {
                pos = globalProps?.intermediateSelector?.selected;
            }
            let offset = hasStart ? 0 : 1
            if (numVisibles > 1) {
                swiperRef.current.slideTo(((pos === 'F' ? maxCol : pos) - numVisibles) - offset)
            } else {
                swiperRef.current.slideTo((pos === 'F' ? maxCol : pos) - offset)
            }


        }
        if (dinamic && globalProps?.intermediateSelector?.isLive) {
            getColsHighlight(globalProps?.intermediateSelector?.current)
        } else if (dinamic) {
            getColsHighlight(globalProps?.intermediateSelector?.selected)
        } else if (!dinamic) {
            getColsHighlight(globalProps?.intermediateSelector?.current)
        }
    }, [globalProps.intermediateSelector])


    const getColsHighlight = (pos) => {
        const extendedColsVisibles = parseInt(globalProps?.intermediateSelector?.extendedColsVisibles);
        const selectedPos = pos === 'F' ? maxCol : parseInt(pos);
        let columns = [];
        for (let i = 1; i <= extendedColsVisibles; i++) {
            let value = ''
            let style = "selected2"
            if (selectedPos <= extendedColsVisibles) {
                value = i + '';
            } else {
                //  if ((i + selectedPos - extendedColsVisibles) === maxCol) {
                //      value = 'F'
                //  } else {
                value = (i + selectedPos - extendedColsVisibles) + ''
                // }
            }
            if (selectedPos <= extendedColsVisibles && i === selectedPos) {
                style = "selected1"
            } else if (selectedPos > extendedColsVisibles && (i + selectedPos - extendedColsVisibles) === selectedPos) {
                style = "selected1"
            }
            columns[i - 1] = { pos: value, style: style };
        }
        setColsH(columns);
    }

    const handleClick = (item) => {
        if (isClickable(item?.position)) {
            // Use Redux to store selected intermediate and set is live to false
            let intermediateSelector = Object.assign({}, globalProps.intermediateSelector);
            intermediateSelector.selected = item?.position;
            intermediateSelector.isLive = false
            dispatch(componentIntermediateSelector(intermediateSelector))
            //higlight component
            getColsHighlight(item?.position);
        }
    }

    let offset = hasStart ? 0 : 1
    const currentPos = data?.currentPosition - offset;

    return (
        <div className='container mirs-timeline-container' >
            < Swiper
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}

                slidesPerView={3}
                //slidesPerView={globalProps.intermediateSelector.selected}
                spaceBetween={0}
                navigation={true}
                pagination={{ clickable: true, }}
                breakpoints={_breakpoints}
                //modules={[A11y]}
                //modules={[Navigation, A11y]}
                modules={[Pagination, Navigation, A11y]}
                className="timeline"
            // observer={true}
            >
                {data?.intermediates?.map((item, index) => {
                    let isActive = index <= currentPos && !config?.hideProgress
                    let className = isActive ? "progression-point active" : "progression-point non-active";
                    let hasCursor = dinamic && item?.position !== 'S'
                    className = hasCursor ? className + " cursorPointer" : className;
                    let style = colsH.find(col => Number(col?.pos) === Number(item?.position))?.style;
                    let labelComponent = renderLabelGEN(item, config, data, style)
                    const _progress_bar = ['TRI']
                    if (_progress_bar.find(item => item === mirs_discipline)) {
                        labelComponent = renderLabelTRI(item, config, data, style)
                    }
                    return (
                        <SwiperSlide
                            className='timeline-item'
                            //data-unit={data?.code} //data.code
                            key={`timeline-item${index}`}
                        >
                            <span
                                className={className}
                                onClick={() => handleClick(item)}>
                                {labelComponent}
                            </span>
                        </SwiperSlide >
                    );
                }
                )}
            </Swiper>
        </div >


    );
}

export const ProgressBarOWS = ({ data, config, dinamic, }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const swiperRef = useRef()
    const globalProps = useSelector(getGlobalProps)
    const dispatch = useDispatch();
    const [colsH, setColsH] = useState([]);
    const isClickable = (pos) => {
        return dinamic && pos !== 'S'
    }
    const maxCol = parseInt(data?.finalPosition);
    //Change this in order to pass by config
    if (!config?.numColVisibles) {
        config.numColVisibles = { sm: 1, lg: 3 }
    }


    const extendedColsVisibles = breakPoint === "sm" || breakPoint === "xs" ? config.numColVisibles?.sm : config.numColVisibles?.lg;

    useEffect(() => {
        const currentSplit = data.currentPosition
        const finalPosition = data.finalPosition
        let intermediateSelector = Object.assign({}, globalProps.intermediateSelector);
        intermediateSelector.current = currentSplit?.toString();
        intermediateSelector.extendedColsVisibles = extendedColsVisibles;
        intermediateSelector.finalPosition = finalPosition
        if (intermediateSelector.isLive) {
            intermediateSelector.selected = currentSplit?.toString();
        }
        dispatch(componentIntermediateSelector(intermediateSelector))
    }, [data, extendedColsVisibles])

    useEffect(() => {
        let numVisibles = globalProps?.intermediateSelector?.extendedColsVisibles ? globalProps?.intermediateSelector?.extendedColsVisibles - 1 : 1
        let pos = 0;
        if (globalProps?.intermediateSelector?.current) {
            if (globalProps?.intermediateSelector?.isLive) {
                pos = globalProps?.intermediateSelector?.current;
            } else {
                pos = globalProps?.intermediateSelector?.selected;
            }
            swiperRef.current.slideTo((pos === 'F' ? maxCol : pos) - numVisibles)
        }

        if (dinamic && globalProps?.intermediateSelector?.isLive) {
            getColsHighlight(globalProps?.intermediateSelector?.current)
        } else if (dinamic) {
            getColsHighlight(globalProps?.intermediateSelector?.selected)
        } else if (!dinamic) {
            getColsHighlight(globalProps?.intermediateSelector?.current)
        }
    }, [globalProps.intermediateSelector])


    const getColsHighlight = (pos) => {
        const extendedColsVisibles = parseInt(globalProps?.intermediateSelector?.extendedColsVisibles);

        const selectedPos = pos === 'F' ? maxCol : parseInt(pos);
        let columns = [];
        for (let i = 1; i <= extendedColsVisibles; i++) {
            let value = ''
            let style = "selected2"
            if (selectedPos <= extendedColsVisibles) {
                value = i + '';
            } else {
                if ((i + selectedPos - extendedColsVisibles) === maxCol) {
                    value = 'F'
                } else {
                    value = (i + selectedPos - extendedColsVisibles) + ''
                }
            }
            if (selectedPos <= extendedColsVisibles && i === selectedPos) {
                style = "selected1"
            } else if (selectedPos > extendedColsVisibles && (i + selectedPos - extendedColsVisibles) === selectedPos) {
                style = "selected1"
            }
            columns[i - 1] = { pos: value, style: style };
        }
        setColsH(columns);
    }

    const handleClick = (item) => {
        if (isClickable(item.pos)) {
            // Use Redux to store selected intermediate and set is live to false
            let intermediateSelector = Object.assign({}, globalProps.intermediateSelector);
            intermediateSelector.selected = item.pos;
            intermediateSelector.isLive = false
            dispatch(componentIntermediateSelector(intermediateSelector))
            //higlight component
            getColsHighlight(item.pos);
        }
    }

    const currentPos = Number(data?.currentPosition);

    return (
        <div className='container mirs-timeline-container' >
            < Swiper
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
                // slidesPerView={globalProps.intermediateSelector.selected}
                spaceBetween={0}
                navigation={true}
                pagination={{ clickable: true, }}
                breakpoints={{
                    576: {
                        slidesPerView: 3,
                        //spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 4,
                        //spaceBetween: 40,
                    },
                    1024: {
                        slidesPerView: 6,
                        //spaceBetween: 50,
                    },
                }}
                modules={[Pagination, Navigation, A11y]}
                className="timeline"
            // observer={true}
            >
                {data?.intermediates?.map((item, index) => {
                    let isActive = index <= currentPos && !config?.hideProgress
                    let className = isActive ? "progression-point active" : "progression-point non-active";
                    let hasCursor = dinamic && item.pos !== 'S'
                    className = hasCursor ? className + " cursorPointer" : className;
                    let style = colsH.find(col => col.pos === item.pos)?.style;
                    return (

                        <SwiperSlide
                            className='timeline-item'
                            data-unit={data.code}
                            key={`timeline-item${index}`}
                        >
                            <span
                                //key={`progress-item-${index}`}
                                className={className}
                                onClick={() => handleClick(item)}>
                                {renderLabelOws(item, config, data, style, mirs_discipline)}
                            </span>
                        </SwiperSlide >
                    );
                }
                )}
            </Swiper>
        </div >


    );
}

export const SimpleProgressBar = ({ data, numElements }) => {

    let params = useUrlFriendlyToParameters();
    //copy parameters URL to change 
    let paramsURL = { ...params }
    const swiperRef = useRef()
    const navigate = useNavigate();
    const handleClick = useCallback((item) => {
        //setValue(key);
        paramsURL["mirs_rsc"] = item.code
        const url = getURL(paramsURL, 'results')
        item.active && navigate(url, { replace: true })
    }, [navigate]);

    const currentPos = Number(data?.currentPosition);

    return (
        data?.intermediates.length > 0 && <div className='container mirs-timeline-container' >
            < Swiper
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
                // slidesPerView={globalProps.intermediateSelector.selected}
                spaceBetween={0}
                navigation={true}
                pagination={{ clickable: true, }}
                slidesPerView={numElements}
                modules={[A11y]}
                className="timeline"
            // observer={true}
            >
                {data?.intermediates?.map((item, index) => {

                    let className = scheduleIsHigherGettingReady(item?.status) ? "progression-point active" : "progression-point unActive"
                    let style = currentPos >= index ? 'selected1' : '';
                    return (

                        <SwiperSlide
                            className='timeline-item'
                            data-unit={data.code}
                            key={`timeline-item${index}`}
                        >
                            <span
                                //key={`progress-item-${index}`}
                                className={className}
                                onClick={() => handleClick(item)}>
                                <div className={`box-data${style ? ' ' + style : ''}`}>
                                    <div className='box-data-up'>{item?.value}</div>
                                </div>
                            </span>
                        </SwiperSlide >
                    );
                }
                )}
            </Swiper>
        </div >


    );
}




export default ProgressBar;



